import React from "react"

const Facebook = () => {
  const [fill, setFill] = React.useState("#EDDBBE")

  React.useEffect(() => {
    const facebook = document.getElementById("footer-facebook-icon")
    facebook.addEventListener("mouseenter", () => {
      setFill("#ffffff")
    })
    facebook.addEventListener("mouseleave", () => {
      setFill("#EDDBBE")
    })
  })

  return (
    <svg
      width="8px"
      height="16px"
      viewBox="0 0 8 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      id="footer-facebook-icon"
    >
      <title>Shape</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="/g/footer"
          transform="translate(-928.000000, -70.000000)"
          fill={fill}
        >
          <path
            d="M933.319786,86 L929.772539,86 L929.772539,77.9989902 L928,77.9989902 L928,75.2421106 L929.772539,75.2421106 L929.772539,73.586973 C929.772539,71.3380459 930.772878,70 933.616745,70 L935.983743,70 L935.983743,72.7578894 L934.504369,72.7578894 C933.397277,72.7578894 933.324121,73.1431457 933.324121,73.862156 L933.319244,75.2421106 L936,75.2421106 L935.686243,77.9989902 L933.319244,77.9989902 L933.319244,86 L933.319786,86 Z"
            id="Shape"
          ></path>
        </g>
      </g>
    </svg>
  )
}

export default Facebook
